<template>
    <div ref="form">
        <div class="vx-card__title mb-4">
            <h4 class="mb-4">Register</h4>
            <p>Confirm your email address and we'll email you a link to reset your password.</p>
        </div>

        <div>
            <vs-input
                name="first name"
                icon-no-border
                icon="icon-user"
                icon-pack="feather"
                placeholder="First Name"
                v-model="firstName"
                class="w-full inline-validation"
                v-validate="'required'"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                :success="!!firstName && !errors.has('first name')"
                :danger="errors.has('first name')"
                :danger-text="errors.first('first name')"
            />

            <vs-input
                name="email"
                icon-no-border
                icon="icon-mail"
                icon-pack="feather"
                placeholder="Email"
                v-model="localEmail"
                v-validate="'required|email'"
                class="w-full inline-validation mt-2"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                @input="emailTaken = false"
                :success="!emailTaken && !!email && !errors.has('email')"
                :danger="emailTaken || errors.has('email')"
                :danger-text="
                    emailTaken ? 'This email is already registered' : errors.first('email')
                "
            />

            <vs-input
                type="password"
                name="password"
                icon-no-border
                icon="icon-lock"
                icon-pack="feather"
                placeholder="Password"
                v-model="password"
                class="w-full inline-validation mt-2"
                v-validate="'required|password'"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                :success="!!password && !errors.has('password')"
                :danger="errors.has('password')"
                :danger-text="errors.first('password')"
            />

            <vs-input
                type="password"
                name="password confirmation"
                icon-no-border
                icon="icon-lock"
                icon-pack="feather"
                placeholder="Confirm Password"
                v-model="passwordConfirm"
                class="w-full inline-validation mt-2"
                v-validate="{ required: true, is: password, regex: '', regex: '' }"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                @keyup.enter="submit"
                :success="!!passwordConfirm && !errors.has('password confirmation')"
                :danger="errors.has('password confirmation')"
                :danger-text="errors.first('password confirmation')"
            />

            <vx-button tabindex="-1" class="mt-4" @click="$emit('cancel')" type="border"
                >Cancel</vx-button
            >
            <vx-button :disabled="!validated || success" class="float-right mt-4" @click="submit"
                >Submit</vx-button
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'register',
    props: {
        email: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            firstName: '',
            password: '',
            passwordConfirm: '',
            emailTaken: false,
            registerDisabled: false,
            success: false
        }
    },
    computed: {
        localEmail: {
            get() {
                return this.email
            },
            set(val) {
                this.$emit('update:email', val)
            }
        },
        validated() {
            return (
                !(this.registerDisabled || this.emailTaken || this.errors.any()) &&
                this.email !== '' &&
                this.password !== '' &&
                this.firstName !== '' &&
                this.passwordConfirm !== ''
            )
        }
    },
    methods: {
        async submit() {
            if (await this.$validator.validate()) {
                try {
                    this.startLoad(this.$refs.form)
                    var minDelay = this.delayFor(1000)
                    var response = await this.$api.auth.register(
                        this.firstName,
                        this.localEmail,
                        this.password
                    )

                    await minDelay
                    this.notifySuccess(
                        'User Registered',
                        `Successfully registered ${this.email}.<br><br>Please check your email to verify your account.`,
                        5000
                    )
                    this.success = true
                    this.endLoad(this.$refs.form)
                    await this.delayFor(1000)
                    this.$emit('cancel')
                } catch (error) {
                    if (error.response.status == 409) {
                        this.emailTaken = true
                        this.notifyError(
                            'Error',
                            `${this.email} is already registered. Please attempt to recover your password or use another email address.`
                        )
                    } else {
                        this.notifyServerError(error)
                        // this.notifyError('Error', `Something wen't wrong that shouldnt have.`)
                    }
                    this.endLoad(this.$refs.form)
                }
            }
        }
    },
    mounted() {
        const dict = {
            custom: {
                'password confirmation': {
                    is: 'Your passwords do not match'
                }
            }
        }
        this.$validator.localize('en', dict)
    }
}
</script>
